import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

interface NewVersionStore {
  hasNewVersion: boolean;
  setHasNewVersion: (state: boolean) => void;
  resetStore: () => void;
}

export const useNewVersionStore = create<NewVersionStore>()(
  devtools(
    persist(
      (set) => ({
        hasNewVersion: false,
        setHasNewVersion: (hasNewVersion) => set({ hasNewVersion }),
        resetStore: () => set({ hasNewVersion: false }),
      }),
      { name: "NewVersionStore", storage: createJSONStorage(() => localStorage) },
    ),
  ),
);
